import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetOrganizationSettings = () => {
    const { zoneApiClient } = useZoneContext();
    return useQuery({
        queryKey: ['get-org-settings'],
        queryFn: async () => {
            const response = await zoneApiClient.getOrganizationSettings();

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve organization settings.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: 5 * 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });
};
